import axios from "@main/axios";
import {PageNav} from "@main/components/page-nav";
import notificationsTemplate from "@partials/notifications.handlebars";

export class Notifications {
    constructor(el) {
        this.el = el;
        this.opnenBtns =  document.querySelectorAll(".js-open-notifications");
        this.url = this.el.dataset.url;
        this.error = this.el.querySelector(".js-notifications-error");
        this.list = this.el.querySelector(".js-notifications-list");
        this.nav = new PageNav(this.el.querySelector(".js-page-nav-notifications"));
        this.countNew = this.el.querySelector(".js-notifications-count-new");
        this.page = 1;
        this.initEvents();
    }

    initEvents() {
        this.opnenBtns.forEach((btn) => {
            btn.addEventListener("click", () => {
                this.loadData();
            });
        });

        this.el.addEventListener("loadList", () => {
            this.loadData();
        });
    }

    loadData = async () => {
        try {
            if (this.el.classList.contains("waiting")) {
                return;
            }
            this.el.classList.add("waiting");
            const params = {page: this.nav.getCurrentPage()};
            const response = await axios({
                url: this.url,
                params,
                method: "get",
            });
            this.el.classList.remove("waiting");
            if (!response?.data) {
                this.showError("Что-то пошло не так...\nПожалуйста, перезагрузите страницу.");
                return;
            }
            if (response.data.success) {
                this.showResult(response.data);
            } else {
                this.showError(response.data.message);
            }
        } catch (error) {
            this.showError(error);
            this.el.classList.remove("waiting");
        }
    }

    showResult(data) {
        if (data.data?.items) {
            this.list.innerHTML = notificationsTemplate({items: data.data.items});
        } else {
            this.list.innerHTML = data.message;
        }
        this.countNew.innerText = data.data?.countNew || 0;
        this.nav.build(data.data?.pages);
    }

    showError(error) {
        this.el.classList.add("error");
        this.error.innerHTML = error;
    }
}

document.querySelectorAll(".js-notifications").forEach(elem => new Notifications(elem));
